import { DEDUCTION_TYPES, IPagingData, SALARY_ENTRY_TYPES } from '@sr/dto';

export const SUMMARY_COLUMNS = [
  { key: SALARY_ENTRY_TYPES.BASE_SALARY, label: 'Оклад' },
  { key: SALARY_ENTRY_TYPES.COMMISSION, label: '% по счетам' },
  { key: SALARY_ENTRY_TYPES.SEEK_COMPENSATION, label: 'Больничные' },
  { key: SALARY_ENTRY_TYPES.VACATION_COMPENSATION, label: 'Отпускные' },
  { key: SALARY_ENTRY_TYPES.BONUS, label: 'Премии' },
  { key: SALARY_ENTRY_TYPES.PREMIUM_FUND_BONUS, label: 'Премия из фонда' },
  { key: SALARY_ENTRY_TYPES.PERCENTAGE_SUPERVISOR, label: '% руководителя' },
  { key: SALARY_ENTRY_TYPES.OTHER_ADDITIONS, label: 'Пр. начисления' },
  { key: SALARY_ENTRY_TYPES.PREPAYMENT, label: 'Аванс' },
  { key: SALARY_ENTRY_TYPES.TAXES, label: 'Налоги' },
  { key: SALARY_ENTRY_TYPES.PENALTY, label: 'Штраф' },
  { key: SALARY_ENTRY_TYPES.OTHER_DEDUCTIONS, label: 'Пр. удержания' },
  { key: SALARY_ENTRY_TYPES.PREMIUM_FUND_RETENTION, label: 'Удержание в фонд' },
].map((column) => ({
  ...column,
  type: DEDUCTION_TYPES.includes(column.key) ? 'deduction' as const : 'addition' as const,
}));

export const useSummaryTableOptions = () => {
  const paging: IPagingData = { itemsPerPage: 100, page: 0 };

  const COLORS = {
    LIGHT_GREEN: '#f5fff5',
    LIGHT_RED: '#ffeded',
    DARK_GREEN: '#006540',
    DARK_RED: '#990000',
    NEUTRAL_GRAY: '#899499',
  };

  const getRowTotalColor = (total: number) => {
    if (total > 0) {
      return COLORS.LIGHT_GREEN;
    }
    if (total < 0) {
      return COLORS.LIGHT_RED;
    }
    return undefined;
  };

  const plusSpan = <span style={{ color: COLORS.DARK_GREEN }}>+</span>;
  const minusSpan = <span style={{ color: COLORS.DARK_RED }}>-</span>;

  const getPriceColor = (price: number, type: 'addition' | 'deduction') => {
    if (price === 0) {
      return COLORS.NEUTRAL_GRAY;
    }
    if (price > 0 && type === 'addition') {
      return COLORS.DARK_GREEN;
    }
    if (price > 0 && type === 'deduction') {
      return COLORS.DARK_RED;
    }
    return undefined;
  };

  const getSpanSize = (price: number) => {
    return price !== 0 ? 'regular' : 'small';
  };

  const columns = [
    { label: 'Сотрудник', align: 'left' as const },
    ...SUMMARY_COLUMNS.map(({ label, type }) => ({
      label,
      color: type === 'addition' ? COLORS.LIGHT_GREEN : COLORS.LIGHT_RED,
      additionalIcon: type === 'addition' ? plusSpan : minusSpan,
    })),
    { label: 'Итого' },
  ];

  return { columns, getSpanSize, getRowTotalColor, getPriceColor, paging };
};
